<script>
import { BNavbarNav } from "bootstrap-vue";

export default {
  extends: BNavbarNav
};
</script>